export default function HeaderSeal() {
  return (
    <svg viewBox="0 0 34 34" className="pf-header-seal" aria-hidden="true">
      <circle cx="17" cy="17" r="15" fill="#7A2E1F" />
      <circle cx="17" cy="17" r="12" fill="none" stroke="#DC4A3D" strokeWidth="0.6" opacity="0.75" />
      <text x="17" y="22" textAnchor="middle" fill="#0B0F10"
            fontFamily="Fraunces, serif" fontWeight="900" fontSize="14">§</text>
    </svg>
  );
}
